module.exports = __webpack_public_path__ + "img/phone-icon-black.64f2d241.svg";